<div class="content-list content enhancement-variant-create">
  <div class="content-list__head">
    <div class="content-header">
      <div class="title">
        Enhancement Variant {{ action === "create" ? "Creation" : "Update" }}
      </div>
      <span class="spacer"></span>
      <h4 class="router-link" (click)="onBack()">Back to List</h4>
      @if (action === 'update') {
        <button
          [disabled]="!readonly"
          mat-icon-button
          matTooltip="Edit"
          [color]="readonly ? 'success' : 'disabled'"
          class="mat-elevation-z0"
          (click)="readonly = false"
          >
          <mat-icon>edit</mat-icon>
        </button>
      }
    </div>
  </div>
  <div
    class="enhancement-variant-create__body"
    [formGroup]="enhancementVariantForm"
    >
    <div
      style="
        justify-content: space-between;
        display: flex;
        align-items: baseline;
      "
      >
      <mat-form-field appearance="outline" style="width: 90%">
        <mat-label>Enhancement Variant Name</mat-label>
        <input
          [readonly]="readonly && action == 'update'"
          matInput
          [formControlName]="'name'"
          autofocus
          />
        @if (enhancementVariantForm.get('name')?.hasError('required')) {
          <mat-error
            >Enhancement Variant Name is required</mat-error
            >
          }
          @if (enhancementVariantForm.get('name')?.hasError('sameName')) {
            <mat-error
              >
              Enhancement Variant Name must be unique in a Master Suite.
            </mat-error>
          }
        </mat-form-field>
        <mat-checkbox
          color="primary"
          formControlName="default"
          [disabled]="readonly || currentDefault!"
          labelPosition="before"
          >
          Default
        </mat-checkbox>
      </div>

      <div class="sub-content">
        <div
          class="content__tab"
          style="--readonly: {{ readonly ? '36px' : '0px' }}"
          >
          <h1 class="title">Selects</h1>

          <div class="list" cdkDropListGroup id="list">
            <div
              cdkDropList
              (cdkDropListEntered)="enter($event)"
              (cdkDropListDropped)="drop()"
              #placeholder
            ></div>
            @for (asset of masterSuiteTouchAssetSelected; track asset; let j = $index) {
              <div
                cdkDropList
                (cdkDropListEntered)="enter($event)"
                (cdkDropListDropped)="drop()"
                >
                <div cdkDrag [cdkDragDisabled]="readonly">
                  <div class="box" [style]="{ width: checkWidth() }">
                    @if (!readonly) {
                      <div class="handle" cdkDragHandle>
                        <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                          <path
                            d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"
                          ></path>
                          <path d="M0 0h24v24H0z" fill="none"></path>
                        </svg>
                      </div>
                    }
                    <!-- Display first previous row -->
                    <app-selected-asset-card
                      [data]="asset"
                      [readonly]="readonly"
                      select="Select {{ j + 1 }}"
                      (remove)="unSelectAsset(asset)"
                      >
                    </app-selected-asset-card>
                  </div>
                </div>
              </div>
            }
          </div>

          <h1 class="title">Available Assets</h1>

          @if (loaded) {
            <div class="available-assets">
              @for (touch of masterSuite.masterSuiteTouches; track touch; let t = $index) {
                <div class="touch">
                  <h3 class="touch-title">Touch {{ t + 1 }}</h3>
                </div>
                <div
                  class="asset-list"
              [ngStyle]="{
                'grid-template-columns':
                  'repeat(' + colPerScreen + ',minmax(0,1fr))'
              }"
                  >
                  @for (asset of parseAssets(touch); track asset; let j = $index) {
                    <div>
                      <app-available-asset-card
                        [data]="asset"
                        [readonly]="readonly"
                        [selected]="checkSelect(asset)"
                        (selectionChange)="onSelectMasterSuite($event, asset, t)"
                        >
                      </app-available-asset-card>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>

        <div class="content-actions">
          <span class="spacer"></span>
          @if (action === 'create' || !readonly) {
            <button
              mat-stroked-button
              (click)="onCancel()"
              >
              Cancel
            </button>
          }
          @if (action === 'create') {
            <button
              mat-stroked-button
              color="buttonSuccess"
              style="margin-left: 20px"
              (click)="create()"
              >
              Create
            </button>
          }
          @if (action === 'update' && !readonly) {
            <button
              mat-stroked-button
              color="buttonSuccess"
              style="margin-left: 20px"
              (click)="update()"
              >
              Update
            </button>
          }
        </div>
      </div>

      <ng-template #noId>
        <button mat-raised-button color="accent" disabled="true" class="asset">
          Please Save EV to Upload Asset
        </button>
      </ng-template>
    </div>
  </div>
